<template>
  <q-select
    :model-value="modelValue"
    label="Status"
    :options="options"
    options-dense
    outlined
    dense
    clearable
    @update:model-value="$emit('update:modelValue', $event)"
    @clear="$emit('clear')"
    class="q-mb-sm"
  >
    <template v-slot:selected>
      <q-item class="select-option select-option__selected">
        <q-item-section avatar>
          <q-icon v-if="modelValue === 'removed'" name="close" color="grey" size="15px"></q-icon>
          <span v-else-if="modelValue" :class="modelValue"></span>
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ modelValue }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:option="scope">
      <q-item class="select-option" v-bind="scope.itemProps">
        <q-item-section avatar>
          <q-icon v-if="scope.opt === 'removed'" name="close" color="grey" size="15px"></q-icon>
          <span v-else :class="scope.opt.replace(/\s+/g, '')"></span>
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ scope.opt }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
export default {
  name: 'StatusSelect',
  props: {
    modelValue: {
      type: String,
    },
    options: {
      type: Array,
      default: () => [
        'completed',
        'pending',
        'inprogress',
        'not started',
        'error',
        'incident',
        'terminated',
        'abandoned',
      ],
    },
  },
};
</script>

<style lang="scss" scoped>
.select-option {
  &__selected {
    padding: 0;
    min-height: 24px;
  }
  .q-item__label {
    text-transform: capitalize;
  }
  .q-item__section--avatar {
    min-width: 25px;
    padding-right: 5px;

    span {
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      margin-right: 4px;
      background-color: $red;

      &.cancelled,
      &.terminated,
      &.abandoned {
        background-color: $grey-6;
      }

      &.inprogress {
        background-color: $orange;
      }

      &.pending {
        background-color: $yellow-7;
      }

      &.completed,
      &.resolved {
        background-color: $green;
      }
    }
  }
}
</style>
